const REGIONAL_INDICATOR_OFFSET = 127397;

export const countryCodeToFlag = (code) => {
  const normalized = String(code || "")
    .trim()
    .toUpperCase();

  if (!/^[A-Z]{2}$/.test(normalized)) return "";

  return normalized
    .split("")
    .map((char) =>
      String.fromCodePoint(char.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET),
    )
    .join("");
};

export const getLocalizedCountryName = (country = {}, lang = "en") => {
  const attrs = country.attributes || country;
  const localizedName = lang === "ar" ? attrs.name_ar : attrs.name_en;

  return localizedName || attrs.name || "";
};

export const getCountryOrderParams = (lang = "en") => ({
  order_by_name_en: lang === "en" ? "asc" : null,
  order_by_name_ar: lang === "ar" ? "asc" : null,
});

export const normalizeCountryOptions = (items = [], lang = "en") =>
  (Array.isArray(items) ? items : []).map((item) => {
    const attrs = item.attributes || item;
    const shortCode = (
      attrs.short_code ||
      ""
    )
      .toString()
      .trim()
      .toUpperCase();

    return {
      id: attrs.id ?? item.id,
      name: getLocalizedCountryName(attrs, lang),
      flag: countryCodeToFlag(shortCode),
      shortCode,
      raw: attrs,
    };
  });
